export default {
    home: '/',
    ranks: '/classifiche',
    upload: '/carica',
    namesakes: '/omonimi',
    admin: '/amministrazione',
    algorithm: '/modifica-algoritmo',
    details: '/dettagli',
    proof: '/certificato'
};